import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

export enum DeviceOptionCmd {
    relocate, lend, reserve, reserveCancel, editLocation, editDevice, duplicate, duplicateFull, // cmds
    save, cancel, end, none // edit commands
}

export enum DeviceOptionState {
    editSingle, editGlobal,
    canEditLocation, onlyEditLocation, noLocationChange,
    none
}

@Injectable({
    providedIn: 'root'
})
export class CommunicationService {

    constructor() {
    }

    // ------ language
    private _browserLanguage: Subject<string> = new Subject();

    get browserLanguage$(): Observable<string> {
        return this._browserLanguage.asObservable();
    }

    set browserLanguage(lang: string) {
        if (lang) this._browserLanguage.next(lang);
    }

    // ------ single device search list browser control
    private _deviceControlPos: BehaviorSubject<number> = new BehaviorSubject(0);

    get deviceControlPos$(): Observable<number> {
        return this._deviceControlPos.asObservable();
    }

    get deviceControlPos(): number {
        return this._deviceControlPos.getValue();
    }

    set deviceControlPos(value: number) {
        this._deviceControlPos.next(value);
    }

    // private _actualDevice: BehaviorSubject<DeviceItem> = new BehaviorSubject(new DeviceItem());
    // get actualDevice$(): Observable<DeviceItem> { return this._actualDevice.asObservable(); }
    // get actualDevice(): DeviceItem { return this._actualDevice.getValue(); }
    // set actualDevice(data: DeviceItem) { this._actualDevice.next(data); }

    // ------ single device action control
    private _deviceOptionCmd: BehaviorSubject<DeviceOptionCmd> = new BehaviorSubject<DeviceOptionCmd>(DeviceOptionCmd.none);

    get deviceOptionCmd$(): Observable<DeviceOptionCmd> {
        return this._deviceOptionCmd.asObservable();
    }

    get deviceOptionCmd(): DeviceOptionCmd {
        return this._deviceOptionCmd.getValue();
    }

    set deviceOptionCmd(value: DeviceOptionCmd) {
        this._deviceOptionCmd.next(value);
    }

    // ------ single device action state
    private _deviceOptionState: BehaviorSubject<DeviceOptionState> = new BehaviorSubject<DeviceOptionState>(DeviceOptionState.none);

    get deviceOptionState$(): Observable<DeviceOptionState> {
        return this._deviceOptionState.asObservable();
    }

    get deviceOptionState(): DeviceOptionState {
        return this._deviceOptionState.getValue();
    }

    set deviceOptionState(value: DeviceOptionState) {
        if (value !== this._deviceOptionState.getValue()) this._deviceOptionState.next(value);
    }


}
